import { ERROR_PREFIXES } from 'src/common/constants';
import { AUTH_EVENT_NAME, AuthEventType } from './constants';
import { emitter } from './emitter';

/**
 * Dispatches an an auth event to the auth event bus which components can listen to
 */
const dispatch = (eventType: AuthEventType) => {
    // eslint-disable-next-line no-console
    console.info(`${ERROR_PREFIXES.APPLICATION_SESSION} ${eventType}`);
    emitter.emit(AUTH_EVENT_NAME, eventType);
};

export { dispatch };
